<template lang="pug">
section.Quantities.pa2-m.pa4-l
  .mw7-ns.tl
    p.f4.mb5.lh-copy.measure.gray(v-html="settings.introductionText")

    h2.f4.f3-l Quantity

    p.f5.lh-copy.measure.gray(v-html="settings.quantityBeforeText")

    .pb2
      .Box
        strong.BoxLabel Number of books
        bookart-number( v-model='model.books', :min=50, :max=5000, :step=1 )

      .Spacer

      .Box
        strong.BoxLabel Number of pages
        bookart-number( v-model='model.pages', :min=4, :max=1024, :step=4 )

    p.f6.lh-copy.measure.gray.pb2(v-html="settings.quantityAfterText")
</template>

<script>

import BookartNumber from './BookartNumber'

export default {
  name: 'bookart-quantities',
  props: ['settings', 'value'],
  computed: {
    model: {
      get () {
        return this.value
      },
      set (value) {
        this.$emit('input', value)
      }
    }
  },
  components: {
    BookartNumber
  }
}
</script>

<style lang="stylus" scoped>

@import '../../styles/vars'

.Box
  display: inline-block
  border: 2px solid $lavender
  background: white
  box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.2)
  padding-left: 1rem
  text-align: center
  white-space: nowrap

.Spacer
  display: block
  height: 1rem

  @media $breakpoints.l
    display: inline-block
    width: 1rem

.BoxLabel
  text-transform: uppercase
  letter-spacing: 0.1em
  font-size: 0.8em
  color: $lavender

  @media $breakpoints.ns
    font-size: 0.9em

.Quantities
  text-align: center

.BookartNumber
  margin-left: 1rem

</style>



// WEBPACK FOOTER //
// BookartQuantities.vue?fcfa60aa